import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { VersionCheckService } from '../../../services/version-check-service.service';

@Component({
  selector: 'sispac-layout',
  templateUrl: './sispac-layout.component.html'
})
export class SispacLayoutComponent implements OnInit {

  public ambiente: string;
  public ehProducao: boolean;
  public nomeDoSistema: string;
  public usuario: any;
  public listarDiarias = false;
  public gestaoSSUrl: string;

  urlVersionFile: string = environment.urlVersionFile;

  constructor(
    private _versionCheckService: VersionCheckService
  ) { }

  ngOnInit() {

    this._versionCheckService.initVersionCheck(this.urlVersionFile);
    this.gestaoSSUrl = environment.apiGestaoSSUrl;
    this.ehProducao = environment.production;

  }
 }



// WEBPACK FOOTER //
// ./src/app/components/_admin-layout/sispac-layout/sispac-layout.component.ts